import type { MouseEvent } from 'react';
import { Brand } from '../components/Brand';
import { TALLY_FORM_ID } from './ManifestoCTA';

function openTally(e: MouseEvent<HTMLAnchorElement>) {
  e.preventDefault();
  if (typeof window === 'undefined' || !window.Tally) return;
  window.Tally.openPopup(TALLY_FORM_ID, { layout: 'modal', width: 700, autoClose: 3000 });
}

// Anchors live on the landing — prefix with "/" only when we're not already there,
// so clicking from / scrolls in-place without a reload.
const onLanding = typeof window !== 'undefined' && window.location.pathname === '/';
const anchor = (id: string) => (onLanding ? `#${id}` : `/#${id}`);

export function Footer() {
  return (
    <footer data-screen-label="08 Footer">
      <div className="wrap">
        <div className="foot">
          <div className="foot-col">
            <Brand href="/" />
            <p className="foot-tag">
              Un seul fil musical, toutes les plateformes. Le protocole de la circulation musicale.
            </p>
          </div>
          <div className="foot-col">
            <div className="h">Pages</div>
            <ul>
              <li><a href="/">Accueil</a></li>
              <li><a href="https://playlist.furtif.fm">Playlists</a></li>
              <li><a href="/manifesto.html">Manifeste</a></li>
              <li><a href="/sondage.html">Sondage</a></li>
            </ul>
          </div>
          <div className="foot-col">
            <div className="h">Le projet</div>
            <ul>
              <li><a href={anchor('protocole')}>Protocole</a></li>
              <li><a href={anchor('playlists')}>Playlists collaboratives</a></li>
              <li><a href={anchor('manifeste')}>Roadmap</a></li>
              <li><a href={anchor('acces')} onClick={openTally}>Accès anticipé</a></li>
              <li><a href="mailto:contact@furtif.fm">Contact</a></li>
            </ul>
          </div>
          <div className="foot-col">
            <div className="h">Statut</div>
            <ul>
              <li style={{ fontFamily: 'var(--font-mono)', fontSize: '.78rem', color: 'var(--moss)' }}>● en construction</li>
              <li style={{ fontFamily: 'var(--font-mono)', fontSize: '.78rem', color: 'var(--cream-3)' }}>v0 · alpha privée</li>
            </ul>
          </div>
        </div>
        <div className="foot-bottom">
          <span>© 2026 furtif.fm</span>
          <span>passer le mur du son</span>
        </div>
      </div>
    </footer>
  );
}
